import React, { useState, useEffect, useCallback } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useForm, Controller } from 'react-hook-form';
import FlexSelect from 'components/Inputs/FlexSelect';
import OverTimesService from '../ExtraHour/service';
import './style.css';

import bootstrapPlugin from '@fullcalendar/bootstrap';
import { Card, CardBody, Container, Row, CardHeader } from 'reactstrap';

import { BsFillCalendarFill, BsPersonLinesFill } from 'react-icons/bs';

import { addDays } from 'date-fns';

import UserService from '../User/service';
import CalendarService from './service/CalendarService';

import { toast } from 'react-toastify';

import { ButtonLogo, HeaderCalendar } from './style/index';

import { useHistory } from 'react-router';

import SimpleHeaderOffButton from 'components/Headers/SimpleHeaderOffButton';
import { SimpleModal } from 'components/Modal/SimpleModal';

import {
  FaBusinessTime,
  FaCalendar,
  FaExpandAlt,
  FaRegClock
} from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { PauseItem } from './components/scalesModal/pause';
import { IconLogoHeader } from 'views/Scales/style/style';

const daysOfWeekMap = new Map([
  [0, 'sunday'],
  [1, 'monday'],
  [2, 'tuesday'],
  [3, 'wednesday'],
  [4, 'thursday'],
  [5, 'friday'],
  [6, 'saturday']
]);

export default function CalendarViewScales() {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const [login, setLogin] = useState(localStorage.getItem('login'));

  const [user, setUser] = useState('');
  const [users, setUsers] = useState('');
  const [automaticPause, setAutomaticPause] = useState([]);
  const [totalOvertimesInMinutes, setTotalOvertimesInMinutes] = useState(0);
  const { control, setValue } = useForm();

  const [scaleDayInfo, setScaleDayInfo] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventData, setEventData] = useState(undefined);

  const toggleModal = () => setIsModalOpen((prev) => !prev);

  const [visibleDateRange, setVisibleDateRange] = useState({
    start: '',
    end: ''
  });

  const [calendarEvents, setCalendarEvents] = useState([]);
  const handleDatesSet = (dateInfo) => {
    setVisibleDateRange({
      start: dateInfo.start,
      end: dateInfo.end
    });
  };

  useEffect(() => {
    viewChange();
  }, []);

  const viewChange = async () => {
    const view = localStorage.getItem('viewChangeDayOff');
    let userLocal = {};

    await UserService.get(user?.login || login).then((res) => {
      userLocal = res.data.data;
    });

    if (view && !userLocal.isSupervisor) {
      history.push('/admin/ChangeDayOff');
    } else if (view && userLocal.isSupervisor) {
      history.push('/admin/ChangeDayOffSupervisor');
    }
  };

  const getPauses = () => {
    OverTimesService.getAutomaticPauses(user?.scale?.id)
      .then((response) => {
        setAutomaticPause(response.data.data.automaticPauses);
      })
      .catch((err) => {
        console.error('error', err);
      });
  };

  useEffect(() => {
    UserService.get(user?.login || login)
      .then((res) => setUser(res.data.data))
      .catch((err) => console.log(err));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user) {
      getPauses();
    }
  }, [user]);

  useEffect(() => {
    if (user?.login && visibleDateRange.start && visibleDateRange.end) {
      const fetchData = async () => {
        try {
          const events = await getCalendarData(
            { start: visibleDateRange.start, end: visibleDateRange.end },
            user
          );
          setCalendarEvents(events);
        } catch (error) {
          console.error('Error fetching calendar data:', error);
        }
      };

      fetchData();
    } else {
      setCalendarEvents([]);
    }
  }, [user?.login, visibleDateRange]);

  const getCalendarData = useCallback(async (fetchInfo, currentUser) => {
    try {
      await UserService.getAllAgentsforSupervisor(login)
        .then((res) => {
          setUsers(res.data.data);
        })
        .catch((err) => console.log(err));

      const startMonthTest = fetchInfo.start;

      let currentDay = startMonthTest.getDate();
      let currentMonth = startMonthTest.getMonth();

      if (currentDay === 1) {
        currentMonth += 1;
      } else {
        currentMonth = currentMonth + 2;
      }

      if (currentMonth > 12) {
        currentMonth = 1;
      }

      let scaleData = [];
      let folgaData = [];
      let shouldStop = false;

      await UserService.get(currentUser?.login || login).then((res) => {
        const scaleObject = res.data.data.scale;
        scaleData = scaleObject;
      });
      await CalendarService.getCalendarDayOff(
        currentUser?.login || login,
        fetchInfo.start,
        fetchInfo.end
      ).then((res) => {
        const datesDaysOff = res.data.data.daysOff;
        const datesTimeShift = res.data.data.timeShifts;

        const newDatesTimeShift = datesTimeShift.map((item) => ({
          ...item,
          date: item.requestedDateShift,
          isTimeShift: true
        }));

        const newArray = [];

        datesDaysOff.forEach((item) => {
          const isTimeShift = newDatesTimeShift.find(
            (itemTimeShift) => itemTimeShift.dateTimeShift === item.date
          );

          if (isTimeShift) {
            item.wasChanged = true;
            item.shiftedFrom = isTimeShift.date;
            newArray.push(item);
            newArray.push(isTimeShift);
          } else {
            newArray.push(item);
          }
        });

        folgaData = newArray;
      });

      let nextDate = fetchInfo.start;

      const data = [];

      while (!shouldStop) {
        const dates = getNextWeekDates(nextDate, scaleData, folgaData);

        if (dates.length > 0) {
          data.push(...dates);
          nextDate = addDays(nextDate, 7);
          const nextMonth = nextDate.getMonth() + 1;
          shouldStop = currentMonth !== nextMonth;
        } else {
          shouldStop = true;
        }
      }

      return data.map((event) => {
        if (event.wasChanged) {
          return {
            title: 'Dia de Trabalho Alterado',
            date: toISOFormat(event.date),
            className: 'bg-green',
            allday: true,
            shiftedFrom: event.shiftedFrom
          };
        } else if (event.isDayOff) {
          return {
            title: 'Folga',
            date: toISOFormat(event.date),
            className: 'bg-yellow',
            textColor: 'black',
            allday: true
          };
        } else if (event.isTimeShift) {
          return {
            title: 'Folga Alterada',
            date: toISOFormat(event.date),
            className: 'bg-green',
            allday: true,
            shiftedFrom: event.shiftedFrom
          };
        } else {
          return {
            title: 'Dia de Trabalho',
            date: toISOFormat(event.date),
            className: 'bg-blue',
            allday: true
          };
        }
      });
    } catch (error) {
      toast.error(error);
      return [];
    }
  }, []);

  function getNextWeekDates(startDate, scaleObject, daysOffArray) {
    const dates = [];
    if (!daysOffArray || !scaleObject) {
      return dates;
    }

    Array.from(daysOfWeekMap.keys()).forEach((dayOfWeekNumber) => {
      const nextDayResult = addDays(startDate, dayOfWeekNumber);

      const dayOff = daysOffArray?.find(
        (d) => d.date === nextDayResult.toISOString() && !d.isTimeShift
      );
      const timeShift = daysOffArray?.find(
        (i) => i.date === nextDayResult.toISOString() && i.isTimeShift
      );

      if (dayOff) {
        dates.push({
          isDayOff: true,
          date: dayOff.date,
          wasChanged: dayOff.wasChanged ?? false,
          shiftedFrom: dayOff.shiftedFrom ?? undefined
        });
      } else if (timeShift) {
        dates.push({
          isTimeShift: true,
          date: timeShift.date,
          shiftedFrom: timeShift.dateTimeShift
        });
      } else if (
        scaleObject &&
        scaleObject[daysOfWeekMap.get(nextDayResult.getDay())]
      ) {
        dates.push({
          isDayOff: false,
          date: nextDayResult.toISOString()
        });
      }
    });
    return dates;
  }

  const toISOFormat = (dateNotFormmated) => {
    if (dateNotFormmated !== undefined) {
      const [date] = dateNotFormmated.split('T');
      const [YYYY, MM, DD] = date.split('-');

      return `${YYYY}-${MM}-${DD}`;
    }
  };

  const toReadableFormat = (dateNotFormmated) => {
    if (dateNotFormmated !== undefined) {
      const [date] = dateNotFormmated.split('T');
      const [YYYY, MM, DD] = date.split('-');

      return `${DD}-${MM}-${YYYY}`.replace('"', '');
    }
  };

  function convertDateToDayOfWeek(date) {
    const dayOfWeek = date.getDay() === 6 ? 0 : date.getDay() + 1;
    return daysOfWeekMap.get(dayOfWeek);
  }

  function selectTimeScaleOfDayWeek(dayOfWeek, scale) {
    if (!scale) return 'Escala não definida';

    const startTime =
      scale[
        `beginTime${dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.substring(1)}`
      ];
    const endTime =
      scale[
        `endTime${dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.substring(1)}`
      ];
    const day = scale[dayOfWeek];

    setScaleDayInfo({
      day,
      startTime,
      endTime
    });
  }

  const getOverTimes = (eventData) => {
    const startDate = eventData._instance.range.start;
    const finalDate = new Date(eventData._instance.range.start);
    finalDate.setDate(finalDate.getDate() + 1);
    OverTimesService.getAll({
      startDate,
      finalDate,
      login: user?.login || login
    })
      .then((response) => {
        const overtimesData = response.data.data;

        const simplifyDate = (date) => {
          const d = new Date(date);
          return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        };
        const totalMinutes = overtimesData
          .filter(
            (record) =>
              (record.status === 'APPROVED' || record.status === 'FINISHED') &&
              (record.attendantName === user?.name ||
                record.attendantLogin === user?.login) &&
              simplifyDate(record.date).getTime() ===
                simplifyDate(finalDate).getTime()
          )
          .reduce((sum, record) => sum + record.timeInMinutes, 0);

        setTotalOvertimesInMinutes(totalMinutes);
      })
      .catch((err) => {
        console.error('error', err);
      });
  };

  const handleEventClick = (eventInfo) => {
    setEventData(eventInfo.event);
    getOverTimes(eventInfo.event);
    getPauses();
    selectTimeScaleOfDayWeek(
      convertDateToDayOfWeek(new Date(eventInfo.event._instance.range.start)),
      user?.scale
    );
    toggleModal();
  };

  return (
    <>
      <SimpleHeaderOffButton
        setCreate="/admin/Calender"
        name="List"
        parentName="Lists"
      />

      <Container fluid style={{ backgroundColor: '#ffffff' }} className="mt--6">
        <Card className="card-calendar">
          <CardHeader
            style={{
              display: 'flex',
              gap: '1rem'
            }}
          >
            <IconLogoHeader
              backgroundColor={systemConfiguration.primary_color}
              style={{
                width: '48px',
                height: '48px',
                aspectRatio: '1/1'
              }}
            >
              <BsFillCalendarFill color="white" size={23} />
            </IconLogoHeader>
            <h3
              style={{
                marginTop: '8px'
              }}
            >
              Calendário
            </h3>
            <Container fluid style={{ backgroundColor: '#ffffff' }}>
              <Row>
                <HeaderCalendar
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <ButtonLogo active="true">
                    <BsFillCalendarFill color="#646f85" />
                  </ButtonLogo>
                  <ButtonLogo
                    onClick={() => {
                      if (user.isSupervisor) {
                        history.push('/admin/ChangeDayOffSupervisor');
                      } else {
                        history.push('/admin/ChangeDayOff');
                      }
                    }}
                  >
                    <BsPersonLinesFill color="#646f85" />
                  </ButtonLogo>
                </HeaderCalendar>
              </Row>
            </Container>
            {user?.isSupervisor && (
              <row className="d-flex justify-content-end align-items-center w-50">
                <div className="form-group w-100">
                  <label className="form-control-label">Usuário</label>
                  <Controller
                    control={control}
                    name="users"
                    defaultValue=""
                    render={({ field }) => (
                      <FlexSelect
                        {...field}
                        isClearable={true}
                        dataOptions={users || []}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value={user?.login || ''}
                        onChange={(selected) => {
                          const selectedUser = users.find(
                            (u) => u.login === selected
                          );
                          setUser({
                            ...user,
                            login: selected,
                            name: selectedUser?.name,
                            scale: selectedUser?.scale
                          });
                          setValue('users', selected);
                        }}
                        valueController={setValue}
                        fieldName="users"
                        labelName="name"
                        valueName="login"
                        className="form-control form-control-md"
                      />
                    )}
                  />
                </div>
              </row>
            )}
          </CardHeader>
          <CardBody className="p-3">
            <FullCalendar
              plugins={[dayGridPlugin, bootstrapPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              events={calendarEvents}
              datesSet={handleDatesSet}
              eventContent={(eventInfo) => {
                return (
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexDirection: 'column',
                        padding: '4px'
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          justifyContent: 'center'
                        }}
                        title={
                          eventInfo.event._def.extendedProps.shiftedFrom
                            ? `Alterado do dia ${toReadableFormat(
                                eventInfo.event._def.extendedProps.shiftedFrom
                              )}`
                            : ''
                        }
                      >
                        <FaBusinessTime />
                        <span
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {eventInfo.event.title}
                        </span>
                      </div>
                      <button
                        onClick={() => handleEventClick(eventInfo)}
                        style={{
                          backgroundColor: 'transparent',
                          border: 'none',
                          color: '#f1f5f9',
                          cursor: 'pointer'
                        }}
                      >
                        <FaExpandAlt size={16} />
                      </button>
                    </div>
                    <div
                      style={{
                        background: '#EFEFEF',
                        color: '#6A7591'
                      }}
                    ></div>
                  </div>
                );
              }}
              themeSystem="bootstrap"
              locale="pt-BR"
              buttonText={{
                today: 'Hoje',
                month: 'Mês',
                week: 'Semana',
                day: 'Dia',
                list: 'Lista'
              }}
            />
          </CardBody>
        </Card>
      </Container>
      <SimpleModal
        size="lg"
        isOpen={isModalOpen}
        toggleModal={toggleModal}
        showCloseButton={false}
      >
        <div style={{ padding: '24px' }}>
          <div style={{ marginBottom: '16px' }}>
            <span
              style={{ fontSize: '16px', color: '#838DA4', fontWeight: 600 }}
            >
              Data
            </span>
            <div
              style={{
                marginTop: '-8px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}
            >
              <FaCalendar size={20} color={systemConfiguration.primary_color} />
              <h1
                style={{
                  color: '#6A7591',
                  fontSize: '32px',
                  fontWeight: 'bold'
                }}
              >
                {toReadableFormat(
                  JSON.stringify(new Date(eventData?._instance?.range?.start))
                )}
              </h1>
            </div>
          </div>
          <div
            style={{
              padding: '0 4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <div>
              <span
                style={{ fontSize: '16px', color: '#838DA4', fontWeight: 600 }}
              >
                Horário:
              </span>
              <div
                style={{
                  marginTop: '-8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <FaRegClock size={20} />
                <h2
                  style={{
                    color: '#6A7591',
                    fontSize: '28px',
                    fontWeight: 'bold'
                  }}
                >
                  {scaleDayInfo
                    ? `${scaleDayInfo?.startTime} - ${scaleDayInfo?.endTime}`
                    : 'Horário não definido'}
                </h2>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '12px'
              }}
            >
              <span
                style={{ fontSize: '16px', color: '#838DA4', fontWeight: 600 }}
              >
                Tempo extra:
              </span>
              <h4
                style={{
                  color: '#6A7591',
                  fontSize: '28px',
                  fontWeight: 'bold'
                }}
              >
                {totalOvertimesInMinutes}
              </h4>
              <span
                style={{
                  fontSize: '16px',
                  color: '#838DA4',
                  marginLeft: '-10px'
                }}
              >
                min
              </span>
            </div>
          </div>

          <div
            style={{
              backgroundColor: '#B4BAC8',
              height: '1px',
              width: '100%',
              margin: '24px 0'
            }}
          />

          {automaticPause.map((pause, index) => (
              <PauseItem
              key={index}
              interval_reference={pause.intervalReference}
              trigger_interval={pause.triggerInterval}
              startTime={scaleDayInfo?.startTime}
              endTime={scaleDayInfo?.endTime}
              title={pause.pause.name}
              duration={pause.duration}
            />
          ))}
        </div>
      </SimpleModal>
    </>
  );
}
